import DateInput from './DateInput';
import GenderSelect from './GenderSelect';
import TeamSelect from './TeamSelect';
import ContestSelect from './ContestSelect';
import { Form, Icon, Label, Message } from './';
import { formPropTypes } from './common';

import React from 'react';
import { filter, find, map, max } from 'lodash';

const startsWithSearch = (options, query) =>
  options.filter(option =>
    option.text.toUpperCase().startsWith(query.toUpperCase()),
  );

const EntryForm = ({ formProps, values, meta, onInputChange }) => {
  const contests = map(values.contests, primaryKey =>
    find(meta.contests, { primaryKey }),
  );
  const entryTotalMinimum = max(map(contests, 'entryTotalMinimum'));
  const total = Number.parseInt(values.total, 10) || 0;
  const entryTotalViolation = total > 0 && total < entryTotalMinimum;
  // TODO: Create stateful component with entry total violation delay?

  return (
    <Form {...formProps}>
      <Form.Field
        multiple
        control={TeamSelect}
        name="teams"
        value={values.teams || []}
        meta={meta}
        onChange={onInputChange}
        closeOnChange
        label="Team(s)"
        required
        search
        fluid
      />
      <Form.Field
        control={GenderSelect}
        name="gender"
        value={values.gender || ''}
        meta={meta}
        onChange={onInputChange}
        label="Gender"
        required
        search={startsWithSearch}
        fluid
      />
      <Form.Group widths="equal">
        <Form.Input
          name="familyName"
          value={values.familyName || ''}
          onChange={onInputChange}
          label="Family name"
          placeholder="Family name"
          fluid
        />
        <Form.Input
          name="givenName"
          value={values.givenName || ''}
          onChange={onInputChange}
          label="Given name"
          placeholder="Given name"
          required
          fluid
        />
      </Form.Group>
      <Form.Field
        control={DateInput}
        name="dateOfBirth"
        value={values.dateOfBirth || ''}
        onChange={onInputChange}
        label="Date of birth"
        placeholder="Date of birth"
        fluid
      />
      <Form.Group>
        <Form.Field
          control={ContestSelect}
          multiple
          name="contests"
          value={values.contests || []}
          options={filter(
            meta.contests,
            values.gender
              ? ['ageGroup.gender.primaryKey', values.gender]
              : false,
          )}
          onChange={onInputChange}
          closeOnChange
          meta={meta}
          label="Contest(s)"
          placeholder="Contest(s)"
          required
          search
          width={8}
        />
        <Form.Input
          label="Entry total"
          name="total"
          value={values.total || ''}
          pattern="[1-9]([0-9]+)?"
          onChange={onInputChange}
          labelPosition="right"
          placeholder="Entry total"
          error={entryTotalViolation}
          width={4}
        >
          <input />
          <Label basic>kg</Label>
        </Form.Input>
        {entryTotalMinimum && (
          <Form.Input
            label="Minimum"
            error={entryTotalViolation}
            readOnly
            value={entryTotalMinimum}
            iconPosition="left"
            labelPosition="right"
            width={4}
          >
            <Icon name="lock" />
            <input />
            <Label basic>kg</Label>
          </Form.Input>
        )}
      </Form.Group>
      {entryTotalViolation && (
        <Message
          icon="warning sign"
          header="Minimum entry total violation"
          content="Entry total must be greater or equal to minimum entry total."
          negative
        />
      )}
    </Form>
  );
};
EntryForm.propTypes = formPropTypes;

export default EntryForm;



// WEBPACK FOOTER //
// ./src/components/EntryForm.js